export function withContextHeaders(headers, context) {
  const values = {
    'X-Lang': context.locale,
    'X-country': context.country,
    'X-Visitor-Country': context.visitorCountry,
    'X-Order-Token': context.orderToken,
    'X-Favorite-Token': context.favoriteToken,
  }
  const present = new Set(Object.keys(headers).map(name => name.toLowerCase()))

  for (const [name, value] of Object.entries(values)) {
    if (value && !present.has(name.toLowerCase())) {
      headers[name] = value
    }
  }

  return headers
}
